import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const bDDomainsApi = createApi({
  reducerPath: 'bDDomainsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Blocking-Domains'],
  endpoints: (builder) => ({
    getBlockingDomains: builder.query({
      query: (params) => ({
        url: `/blocking_domain/domains/`,
        params,
      }),
      providesTags: ['Blocking-Domains'],
    }),

    createBlockingDomain: builder.mutation({
      query: (body) => ({
        url: '/blocking_domain/domains/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Blocking-Domains'],
    }),

    getBlockingDomainById: builder.query({
      query: ({ id, ...params }) => ({
        url: `/blocking_domain/domains/${id}/`,
        params,
      }),
      providesTags: (result, error, { id }) => [{ type: 'Blocking-Domains', id }],
    }),

    updateBlockingDomainById: builder.mutation({
      query: ({ id, body }) => ({
        url: `/blocking_domain/domains/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Blocking-Domains'],
    }),
    

    deleteBlockingDomainById: builder.mutation({
      query: (id) => ({
        url: `/blocking_domain/domains/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Blocking-Domains'],
    }),

    
  }),
});

export const {
  useGetBlockingDomainsQuery,
  useLazyGetBlockingDomainsQuery,
  useCreateBlockingDomainMutation,
  useGetBlockingDomainByIdQuery,
  useUpdateBlockingDomainByIdMutation,
  useDeleteBlockingDomainByIdMutation,
} = bDDomainsApi;
